<template>
  <span
    class="app-pill"
    :class="{
      'app-pill--highlight': highlight,
      'app-pill--medium': medium,
      'app-pill--dark': dark,
      'app-pill--arrow': arrow,
    }"
  >
    <slot />
  </span>
</template>

<script setup>
  defineProps({
    highlight: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
    arrow: {
      type: Boolean,
      default: false,
    },
    arrowPosition: {
      type: String,
      default: 'bottom', // No other variants yet
    },
  })
</script>

<style lang="scss">
  .app-pill {
    font-family: var(--font-family-default);

    font-size: 12px;
    background: var(--color-secondary);
    letter-spacing: 0;
    padding: 2px 8px;
    border-radius: 8px;

    @include breakpoint(sm) {
      font-weight: 700;
      padding: 0 16px;
      border-radius: 32px;
    }
  }

  // Highlight
  .app-pill--highlight {
    background: var(--color-highlight);
    color: white;
  }

  // Medium
  .app-pill--medium {
    border-radius: 6px;
    font-size: 18px;
    padding: 3px 8px;
  }

  // Dark
  .app-pill--dark {
    color: var(--color-primary);
  }

  // With arrow
  .app-pill--arrow {
    position: relative;
  }

  .app-pill--arrow:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 5px;
    border-style: solid;
    border-color: var(--color-secondary) transparent transparent transparent;
  }

  .app-pill--highlight.app-pill--arrow:after {
    border-color: var(--color-highlight) transparent transparent transparent;
  }
</style>
